import DistrictProvider from "../views/agentDistrictProvider/districtProvider";
import DayTable from "../views/agentDistrictProvider/dayTable";
import MonthTable from "../views/agentDistrictProvider/monthTable";
import DomainList from "../views/agentDistrictProvider/domainList";
import AdReview from "../views/agentDistrictProvider/adReview";
import ManageAuthrity from "../views/agentDistrictProvider/manageAuthrity";
import Main from "../views/main";

const AgentDistrictRouter = {
  path: "/district-provider",
  component: Main,
  title: "商区管理",
  icon: "el-icon-s-cooperation",
  meta: { keepAlive: true },
  children: [
    {
      path: "/month-table",
      component: MonthTable,
      name: "monthTable",
      title: "每月报表",
      meta: { title: "每月报表", keepAlive: true },
    },
    {
      path: "/day-table",
      component: DayTable,
      name: "dayTable",
      title: "每日报表",
      meta: { title: "每日报表", keepAlive: true },
    },
    {
      path: "/district-provider",
      component: DistrictProvider,
      name: "districtProvider",
      title: "代理列表",
    },
    {
      path: "/domain-list",
      component: DomainList,
      name: "domainList",
      title: " 域名绑定",
      meta: { title: "域名绑定", keepAlive: true },
    },
    {
      path: "/ad-review",
      component: AdReview,
      name: "adReview",
      title: "广告审核",
      meta: { title: "广告审核", keepAlive: true },
    },
    {
      path: "/mg-review",
      component: ManageAuthrity,
      name: "manageAuthrity",
      title: "代理权限",
      meta: { title: "代理权限", keepAlive: true },
    },
  ],
};
export default AgentDistrictRouter;
